import { createRouter, createWebHistory } from 'vue-router'
import { authGuard } from './guard'
import NotFound from '@/views/NotFound/index.vue'
import { setupChunkLoadRecovery } from '@/utils/appVersion'

// 自动加载modules目录下的所有路由文件
const moduleRoutes = Object.values(import.meta.glob('./modules/*.ts', { eager: true })).flatMap(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (module) => (module as { default: any }).default
)

const sortedMenuItems = JSON.parse(localStorage.getItem('sortedMenuItems') || '[]')
const redirectPath = sortedMenuItems.length > 0 ? sortedMenuItems[0]?.path || '/' : '/notFound'
const redirectMeta =
  sortedMenuItems.length > 0
    ? {
        title: sortedMenuItems[0]?.meta?.title,
        isFullScreen: false,
        keepAlive: false,
        hidden: true,
        prem: true,
      }
    : {}

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    // 自动合并所有模块路由
    ...moduleRoutes,
    {
      path: '/',
      name: 'home',
      redirect: redirectPath,
      meta: redirectMeta,
    },
    // 匹配所有未定义的路由
    {
      path: '/:pathMatch(.*)*',
      name: 'NotFound',
      component: NotFound,
    },
    {
      path: '/noPermission',
      name: 'noPermission',
      component: () => import('@/views/noPermission/index.vue'),
    },
  ],
})
router.beforeEach(authGuard)
setupChunkLoadRecovery(router)

export default router
